import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { ContextRoute, ProtectedRoute } from "./components/AppLayout";
import { ExecutionPage } from "./features/execution/ExecutionPage";
import { LoginPage, ForgotPasswordPage, ResetPasswordPage } from "./pages/AuthPages";
import { CertificatesPage } from "./pages/CertificatesPage";
import { CommunicationsPage } from "./pages/CommunicationsPage";
import { ContextPage } from "./pages/ContextPage";
import { InviteActivationPage } from "./pages/InviteActivationPage";
import { ContractAdminPage } from "./features/contract-admin/ContractAdminPage";
import { SamplingPage } from "./pages/SamplingPage";
import { QualitySpecificationsPage } from "./features/quality-specifications/QualitySpecificationsPage";

export default function App() {
  const location = useLocation();
  const fragment = new URLSearchParams(location.hash.replace(/^#/, ""));
  const query = new URLSearchParams(location.search);
  const inviteReturn = location.pathname !== "/activar-cuenta" &&
    ((fragment.get("type") === "invite" && fragment.has("access_token") && fragment.has("refresh_token")) ||
     (query.get("type") === "invite" && query.has("token_hash")));
  // Compatibilidad con enlaces antiguos que Supabase devolvió a Site URL.
  // Nunca permitir que la sesión general procese las credenciales de invitación.
  if (inviteReturn) {
    return <Navigate to={`/activar-cuenta${location.search}${location.hash}`} replace />;
  }
  return <Routes>
    <Route path="/acceso" element={<LoginPage />} />
    <Route path="/recuperar-contrasena" element={<ForgotPasswordPage />} />
    <Route path="/restablecer-contrasena" element={<ResetPasswordPage />} />
    <Route path="/activar-cuenta" element={<InviteActivationPage />} />
    <Route element={<ProtectedRoute />}>
      <Route path="/contexto" element={<ContextPage />} />
      <Route element={<ContextRoute />}>
        <Route path="/muestreos" element={<SamplingPage />} />
        <Route path="/ejecucion-obra" element={<ExecutionPage />} />
        <Route path="/certificados" element={<CertificatesPage />} />
        <Route path="/comunicaciones" element={<CommunicationsPage />} />
        <Route path="/configuracion-calidad" element={<QualitySpecificationsPage />} />
        <Route path="/administracion-contrato" element={<ContractAdminPage />} />
      </Route>
    </Route>
    <Route path="*" element={<Navigate to="/acceso" replace />} />
  </Routes>;
}
